"use client";

import { useState } from "react";
import { addCartItem } from "@/lib/cart";
import type { CartBlockReason } from "@/lib/cart";
import type { CartItem, CartProduct } from "@/lib/types";

function readCart(): CartItem[] {
  try {
    const parsed = JSON.parse(localStorage.getItem("cart") || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

type AddToCartButtonProps = {
  item: CartProduct;
  blockedReason?: CartBlockReason | null;
};

export function AddToCartButton({ item, blockedReason = null }: AddToCartButtonProps) {
  const [added, setAdded] = useState(false);

  function addToCart() {
    const cart = addCartItem(readCart(), item);
    localStorage.setItem("cart", JSON.stringify(cart));
    window.dispatchEvent(new Event("cart-updated"));
    setAdded(true);
    window.setTimeout(() => setAdded(false), 1600);
  }

  return (
    <button
      type="button"
      onClick={addToCart}
      disabled={blockedReason !== null}
      className="catalog-add-button"
      aria-label={`Добавить «${item.name}» в корзину`}
    >
      {blockedReason === "out_of_stock"
        ? "Нет в наличии"
        : blockedReason === "missing_price"
          ? "Цена уточняется"
          : added ? "Добавлено" : "В корзину"}
    </button>
  );
}
